import ScoreService from "src/services/ScoreService";
import ModuleCreator from "src/store/ModuleCreator";

export const types = {
	FETCH:"score/fetch",
	STORE: "score/store",
};

export const params = {};

/**
@namespace
@property  {object} module,
@property  {object} module.state,
@property  {object} modules.game,
@property  {array}  modules.games
@property  {array}  modules.gamesCount
 **/

const module = {
	actions:{
		async [types.FETCH]({commit}, { game,filters }){
			const scores = await ScoreService.fetch(game,filters);
			commit(types.FETCH,scores.data);
			return scores;
		},
		async [types.STORE](context, scoreParams) {
			const score = await ScoreService.create(scoreParams);
			context.commit(types.STORE, score);
			return score;
		},
	}
};
export default ModuleCreator("score", ScoreService, module, types, params);
